/**
 * Resolves a dot-notation key path against a nested object.
 * Returns the string value at that path, or the original key as fallback
 * if the path does not exist or does not resolve to a string.
 *
 * @example
 * resolveNestedKey({ a: { b: "hello" } }, "a.b") // "hello"
 * resolveNestedKey({ a: { b: "hello" } }, "a.c") // "a.c"
 */
export function resolveNestedKey(obj: unknown, key: string): string {
  const parts = key.split(".");
  let val: unknown = obj;
  for (const part of parts) val = (val as Record<string, unknown>)?.[part];
  return typeof val === "string" ? val : key;
}
